// This file was AUTO-GENERATED by the Typewriter Visual Studio plugin base on the Constants.tst template. 
// !!Do not modify this file or change may be lost!!
/* eslint-disable */
export default class ApprovalStatusType {
    public static readonly PENDING: number = 1;
    public static readonly WAITING: number = 2;
    public static readonly APPROVED: number = 3;
    public static readonly DECLINED: number = 4;
    public static readonly SKIPPED: number = 5;
}
